import Login from '../views/Login'

export default {
  path: '/login',
  name: 'login',
  component: Login
}
